<template>
<div>
  <div style="display: flex;flex-direction: row;margin-bottom: 10px;">
    <el-button size="mini" @click="submitAll">保存</el-button>
    <el-button size="mini" @click="setComponentsId('SaleCarryOverList')">变更日志</el-button>
    <el-button size="mini" @click="hide">取消</el-button>
  </div>
  <div class="main-sell">
    <el-descriptions size="mini" :column="1" border direction="vertical">
      <el-descriptions-item label="应收款明细信息">
        <div>
          <el-descriptions size="mini" :label-style="{width: '80px'}" :column="1" border>
            <el-descriptions-item label="客户">
              <el-row :gutter="5">
                <el-col :span="12">
                  <el-descriptions size="mini" :label-style="{width: '80px'}" :column="1" border>
                    <el-descriptions-item label="老客户">
                      <span v-if="customer_old.id">
                        {{customer_old.name}}（<el-link type="primary" @click="showEditor(customer_old.id)">{{customer_old.id}}</el-link>）
                      </span>
                    </el-descriptions-item>
                    <el-descriptions-item label="证件编号">{{customer_old.credentials_code}}</el-descriptions-item>
                    <el-descriptions-item label="手机号码">{{customer_old.contact_number}}</el-descriptions-item>
                  </el-descriptions>
                </el-col>
                <el-col :span="12">
                  <el-descriptions size="mini" :label-style="{width: '80px'}" :column="1" border>
                    <el-descriptions-item label="新客户">
                      <span v-if="customer_new.id">
                        {{customer_new.name}}（<el-link type="primary" @click="showEditor(customer_new.id)">{{customer_new.id}}</el-link>）
                      </span>
                    </el-descriptions-item>
                    <el-descriptions-item label="证件编号">{{customer_new.credentials_code}}</el-descriptions-item>
                    <el-descriptions-item label="手机号码">{{customer_new.contact_number}}</el-descriptions-item>
                  </el-descriptions>
                </el-col>
              </el-row>
            </el-descriptions-item>
            <el-descriptions-item label="结转日期">
              <el-date-picker
                v-model="form.carry_forward_date"
                type="date"
                size="mini"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
              <span style="color: #ff0000"> &nbsp;&nbsp;&nbsp;&nbsp;*&nbsp;&nbsp;结转时间必须选择（选择之日起即就是新客户的）</span>
            </el-descriptions-item>
            <el-descriptions-item label="结转备注">
              <el-input type="textarea" v-model="remarks" placeholder="填写备注" rows="2"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="收费项">
              <el-checkbox-group v-model="chang_name_ids">
                <el-checkbox size="mini"  v-for="(item,index) in chang_name_list" :key="index" :label="item.id">{{item.chargeItem_name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="操作">
              <el-button size="mini" @click="search">筛选收费项</el-button>
              <el-button v-if="multipleSelection.length" size="mini" type="danger" style="color: #ffffff" @click="removeOrder()">移除应收款</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="操作说明">
              <p>1.费项结转，主要就是把费项结转给新客户！</p>
              <p>2.【结转日期】请必须选择，否则无法进行结转！</p>
              <p>3.【收费项】主要提供筛选出来对应的收费项，筛选出什么样的账单就结转什么样的费项！</p>
              <p>4.【手动调整应收金额】就意味着放弃了系统自动划分新老客户应收款的配比！同时本费项自定义划分账单计费周期必须包含【结转日期】，否则设置无效！系统会自动把结转日期及结转日期后的费用结转给新客户！</p>
<!--              <p>5.【已缴部分金额】如果该账单在计费周期包含【结转日期】，设置了已缴款新老业主配比金额，系统会按照配置结转已缴金额，如果不设置，金额将划归老客户；如果计费周期不包含【结转日期】，即便设置也无效！</p>-->
              <p>5.页面显示哪些费项就会按【结转日期】结转哪些费项，操作人员可以通过勾选移除对应的不需要结转的费项避开计费周期包含【结转日期】的费项进行结转！</p>
              <p>6.冻结账单或者流程中的账单不进行结转</p>
              <p>7.缴了部分钱的账单不进行结转</p>
              <p>8.调整过应收的账单不进行结转</p>
              <p>9.欠费减免过的账单不进行结转</p>
              <p>10.月结的账单暂时不进行结转</p>
              <!--<p><el-button size="mini" type="danger" style="color: #ffffff">结转不了或者不需要结转的账单,先勾选,再点移除应收款按钮,最后点保存按钮进行结转.特殊需要结转的账单等领导们商量后再决定放开</el-button></p>-->
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="width: 100%;display: grid;">
          <el-table
            v-if="pageData" v-loading="loading" :data="pageData.list"
            border
            @selection-change="handleSelectionChange"
            style="width: 100%">
            <el-table-column
              type="selection"
              width="45"></el-table-column>
            <el-table-column prop="customer_name" label="客户名称" align="center" width="150" fixed></el-table-column>
            <!--          <el-table-column prop="number" label="是否在流程中 " align="center" width="100"></el-table-column>-->
            <el-table-column prop="h_name_date" label="房 产" align="center" width="300"></el-table-column>
            <el-table-column prop="ChargeItemName" label="收费标准" align="center" width="240" fixed></el-table-column>
            <el-table-column prop="startDate" label="计费周期" align="center" width="180" fixed>
              <template slot-scope="scope">
                {{scope.row.startDate}} - {{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="should_charge_date" label="应收日期" align="center" width="150"></el-table-column>
            <el-table-column prop="charge_adjust_after" label="应收金额" align="center" width="90"></el-table-column>
            <el-table-column prop="PaidChargeSum" label="已收金额" align="center" width="90"></el-table-column>
            <el-table-column prop="account_book" label="所属日期" align="center" width="80"></el-table-column>
            <el-table-column prop="IsFrozen" label="是否冻结" align="center" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.IsFrozen==1" style="color: #ff3d00;font-weight: bold;">是</span>
                <span v-if="scope.row.IsFrozen!=1" style="color: #2faf0b;font-weight: bold;">否</span>
              </template>
            </el-table-column>
            <!--          <el-table-column prop="account" label="挂账金额" align="center" width="90"></el-table-column>-->
            <el-table-column label="应收金额调整" align="center">
              <el-table-column prop="house_name" label="手动" align="center" width="80">
                <template slot-scope="scope">
                  <el-checkbox size="mini" :value="scope.row.checkbox" :disabled="scope.row.IsFrozen==1" @change="changeCheckbox(scope.row)"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="house_name" label="老客户" align="center" width="120">
                <template slot-scope="scope">
                  <el-input size="mini" placeholder="老业主金额" :disabled="!scope.row.checkbox||scope.row.IsFrozen==1" @input="onDosageNumber(scope.row,'old_money')" v-model="scope.row.old_money" clearable></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="house_name" label="新客户" align="center" width="120">
                <template slot-scope="scope">
                  <el-input size="mini" placeholder="新业主金额" :disabled="!scope.row.checkbox||scope.row.IsFrozen==1" @input="onDosageNumber(scope.row,'new_money')" v-model="scope.row.new_money" clearable></el-input>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="已缴金额调整" align="center">
              <el-table-column prop="house_name" label="老客户(已收)" align="center" width="120">
                <template slot-scope="scope">
                  {{scope.row.old_PaidChargeSum}}
<!--                  <el-input size="mini" placeholder="老业主金额" :disabled="!((scope.row.PaidChargeSum>0)&&isDate(scope.row))||scope.row.IsFrozen==1" @input="onDosageNumber2(scope.row,'old_PaidChargeSum')" v-model="scope.row.old_PaidChargeSum" clearable></el-input>-->
                </template>
              </el-table-column>
              <el-table-column prop="house_name" label="新客户(已收)" align="center" width="120">
                <template slot-scope="scope">
                  {{scope.row.new_PaidChargeSum}}
<!--                  <el-input size="mini" placeholder="新业主金额" :disabled="!((scope.row.PaidChargeSum>0)&&isDate(scope.row))||scope.row.IsFrozen==1" @input="onDosageNumber2(scope.row,'new_PaidChargeSum')" v-model="scope.row.new_PaidChargeSum" clearable></el-input>-->
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>

      </el-descriptions-item>
    </el-descriptions>
  </div>

  <editor v-model="editor.visable" :classValue="editor.classValue" :id="editor.id" :is_edit="false" @callback="editorCallback" />
</div>
</template>

<script>
import Editor from "../../../Customer/editor";
import moment from "moment";

export default {
  name: "SaleCarryOverMain",
  components:{Editor},
  inject:['setComponents','onEventHandel'],
  props:{
    customerOldId:[Number,String],
    customerNewId:[Number,String],
    houseId:[Number,String]
  },
  data(){
    return{
      loading:false,
      visable:false,
      form:{
        carry_forward_date:""
      },
      chang_name_ids:[],
      multipleSelection:[],
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      callback:null,
      chang_name_list:[],
      customer_old:{},
      customer_new:{},
      editor:{
        classValue:1,
        id:0,
        visable:false
      },
      remarks:""
    }
  },
  activated() {
    const that=this;
    that.house_id=that.houseId;
    that.getOrderChangName(()=>{
      that.multipleSelection=[];
      that.pageChange(1);
      that.getCustomerBaseObj()
    })
  },
  watch:{
    houseId(n,o){
      const that=this;
      that.house_id=n;
      n&&that.getOrderChangName(()=>{
        that.multipleSelection=[];
        that.pageChange(1);
        that.getCustomerBaseObj()
      })
    },
    "form.carry_forward_date":function (n,o) {
      this.pageData.list=this.pageData.list.map(ret=>{
        ret.checkbox=false;
        ret.old_money="";
        ret.new_money="";
        ret.old_PaidChargeSum=ret.PaidChargeSum;
        ret.new_PaidChargeSum="";
        return ret;
      })
    }
  },
  methods:{
    getCustomerBaseObj(){
      const that=this;
      that.customer_old={};
      that.customer_new={};
      ERP.postRequest({url: "admin/SaleCarryOver/getCustomerBaseObj", data: {
          customer_old_id:that.customerOldId,
          customer_new_id:that.customerNewId,
        }
      }, res => {
        if (res.code) {
          that.customer_old=res.data.customer_old||{};
          that.customer_new=res.data.customer_new||{};
        }
      })
    },
    getOrderChangName(callback){
      const that=this;
      ERP.postRequest({url: "admin/SaleCarryOver/getOrderChangName", data: {
          house_id:that.house_id
        }
      }, res => {
        if (res.code) {
          that.chang_name_list=res.data
          that.chang_name_ids=res.data.map(ret=>ret.id)
          typeof callback==="function"&&callback()
        }
      })
    },
    getList(){
      const that=this;
      that.loading=true;
      ERP.postRequest({url: "admin/SaleCarryOver/getOrderList", data: {
          house_id:that.house_id,
          chang_name_ids:that.chang_name_ids.join(','),
          // pageSize:that.pageData.pageSize,
          // page:that.pageData.page,
        }
      }, res => {
        if (res.code) {
          // console.log(res.data);
          res.data.list.map(ret=>{
            ret.checkbox=false;
            ret.old_money="";
            ret.new_money="";
            // ret.PaidChargeSum="100";
            ret.old_PaidChargeSum=ret.PaidChargeSum;
            ret.new_PaidChargeSum="";
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    search(){
      const that=this;
      that.multipleSelection=[];
      that.pageChange(0)
    },
    onDosageNumber(item,name="old_money"){
      if(item.checkbox){
        if(name==='old_money'){
          item.new_money=item.charge_adjust_after-item.old_money;
        }else {
          item.old_money=item.charge_adjust_after-item.new_money;
        }
      }
    },
    onDosageNumber2(item,name="old_money"){
      if(name==='old_PaidChargeSum'){
        item.new_PaidChargeSum=item.PaidChargeSum-item.old_PaidChargeSum;
      }else {
        item.old_PaidChargeSum=item.PaidChargeSum-item.new_PaidChargeSum;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    changeCheckbox(item){

      if(!this.form.carry_forward_date){
        this.$message.error('请选择【结转日期】')
        return false
      }

      let startDate=moment(item.startDate).format('x')
      let endDate=moment(item.endDate).format('x')
      let carry_forward_date=moment(this.form.carry_forward_date).format('x')

      if(carry_forward_date>=startDate&&carry_forward_date<=endDate){
        item.checkbox=!item.checkbox
        if(!item.checkbox){
          item.old_money="";
          item.new_money="";
        }else {
          this.$alert('选择手动调整，就意味着放弃了系统自动划分新老客户应收款的配比！同时本自定义划分账单计费周期必须包含【结转日期】，否则设置无效！\n系统会自动把结转日期及结转日期后的费用结转给新客户！', '提示', {
            confirmButtonText: '确定',
            callback: action => {}
          });
        }
      }else {
        this.$message.error('计费周期不包含设置的结转日期，不能设置！')
      }

    },
    removeOrder(){
      const that=this;
      let select_ids=that.multipleSelection.map(ret=>ret.id);
      let list=that.pageData.list.filter(ret=>(select_ids.indexOf(ret.id)===-1));
      that.pageData.list=reObject(list)
      that.multipleSelection=[];
    },
    show(data){
      // console.log(data)
      const that=this;
      that.callback=data.callback;
      that.house_id=data.house_id;
      that.house_sale_log_id=data.house_sale_log_id;
      that.visable=true;
      that.$forceUpdate();
      that.getOrderChangName(()=>{
        that.getData();
      })
    },
    hide(){
      this.onEventHandel("SaleCarryOverMain",'hide')
    },
    submitAll(){
      const that=this;
      if(!that.form.carry_forward_date){
        that.$message.error('必须选择结转时间')
        return false;
      }
      if(!that.customerNewId){
        that.$message.error('无新用户')
        return false;
      }
      if(!that.houseId){
        that.$message.error('请选择房产')
        return false;
      }
      let list=that.pageData.list.filter(ret=>{
        return ret.IsFrozen != 1 && ret.PaidChargeSum<=0
      })
      // let data={
      //   customer_old_id:that.customerOldId,
      //   customer_new_id:that.customerNewId,
      //   split_date:that.form.carry_forward_date,
      //   list_str:JSON.stringify(list),
      //   house_id:that.houseId,
      //   list:that.pageData.list,
      //   remarks:that.remarks,
      // };
      // // console.log(data)
      // ERP.postRequest({url: "admin/SaleCarryOver/saveChangeOver", data: data}, res => {
      //   if (res.code) {
      //     that.setComponentsId('SaleCarryOverList');
      //   }else {
      //     that.$message.error(res.msg||'数据查询失败');
      //   }
      // })

      let _order_list=list.map(ret=>{
        return{
          id:ret.id,
          type:ret.checkbox?1:0,
          AgedMoney:ret.old_money,
          NewMoney:ret.new_money
        }
      })
      let data={
        CustomerAgedId:that.customerOldId,
        CustomerNewId:that.customerNewId,
        SplitData:that.form.carry_forward_date,
        Order:_order_list,
        house_id:that.houseId,
        // list:that.pageData.list,
        remarks:that.remarks,
      };
      // console.log(data)
      ERP.postRequest({url: "admin/UserOrderSplit/Split", data: data}, res => {
        if (res.code==200) {
          that.setComponentsId('SaleCarryOverList');
        }else {
          that.$message.error(res.message||'数据查询失败');
        }
      })
    },
    showEditor(customer_id) {
      const that=this;
      that.getCustomerBase(customer_id,data=>{
        that.editor.classValue = data.class
        that.editor.id = customer_id
        that.editor.visable = true
      })
    },
    getCustomerBase(customer_id,callback){
      ERP.getRequest({
        url: "admin/Customer/getCustomerBase",
        data: {
          id: customer_id,
        }
      }, res => {
        if (res.code) {
          typeof callback ==="function"&&callback(res.data);
        }
      })
    },
    editorCallback(arg) {
      // this.getList()
      if(arg && arg[0]) this.editor.id = arg[0]
    },
    isDate(item){
      if(!this.form.carry_forward_date){
        return false
      }

      let startDate=moment(item.startDate).format('x')
      let endDate=moment(item.endDate).format('x')
      let carry_forward_date=moment(this.form.carry_forward_date).format('x')

      return carry_forward_date >= startDate && carry_forward_date <= endDate;
    },
    setComponentsId(componentsId){
      this.setComponents(componentsId)
    }
  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
.main-sell{
  //height: calc(100vh - 300px);
  //overflow-y: scroll;
}
>>>.el-table--border, .el-table--group{
  border: 1px solid #000000;
}
>>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  border-bottom: 1px solid #000000;
}
>>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
  border-right: 1px solid #000000;
}
>>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  border-bottom: 1px solid #000000;
}
>>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
  border-bottom: 1px solid #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/SaleCarryOverMain.vue